import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import cookie_45check_45global from "/src/middleware/cookie-check.global.ts";
import monetate_45global from "/src/middleware/monetate.global.ts";
import user_45guest_45checkout_45global from "/src/middleware/user-guest-checkout.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  cookie_45check_45global,
  monetate_45global,
  user_45guest_45checkout_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "builder-page-error": () => import("/src/middleware/builder-page-error.ts"),
  "buynow-protect": () => import("/src/middleware/buynow-protect.ts"),
  "checkout-protect": () => import("/src/middleware/checkout-protect.ts"),
  "is-logged-in": () => import("/src/middleware/is-logged-in.ts"),
  protected: () => import("/src/middleware/protected.ts"),
  "redirect-to-slug": () => import("/src/middleware/redirect-to-slug.ts")
}